import React from 'react'

type Props = {
    className?          : string
    searchString?       : string
    placeholder?        : string

    showDeleteButton?   : boolean

    onEnterPressed?     : callback
    onEscapePressed?    : callback
    onSearch            : callback
    onClear?            : callback
}

export default class Search extends React.Component<Props> {

    static defaultProps = {
        placeholder: "Search"
    }

    public searchInput: React.RefObject<any> = React.createRef()

    componentDidMount() {
        this.searchInput.current.focus({preventScroll: true})
    }

    // we want to handle esc here to close
    onKeyDown = (event: React.KeyboardEvent) => {
        switch(event.key){
            case 'Enter': if (this.props.onEnterPressed) this.props.onEnterPressed(); break;
            case 'Escape': if (this.props.onEscapePressed) this.props.onEscapePressed(); return;
        }
    };

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let newValue = event.target.value;
        newValue = newValue.length > 0 ? newValue /*newValue.toLowerCase()*/ : "";
        this.props.onSearch(newValue);
    }

    onSearchCancel = () => {
        this.props.onSearch("");
        if (this.props.onClear) this.props.onClear();
    }

    render() {
        return (
            <div className={Classes('gd-popover-search', this.props.className)}>
                <div className="icon-holder">
                    <div className="ui5-ico-14 i5-search search-icon flex-row-center-center w-30 h-100-percent"/>
                </div>
                <input ref          = {this.searchInput}
                       placeholder  = {this.props.placeholder}
                       value        = {this.props.searchString ? this.props.searchString : ""}
                       onChange     = {this.onChange}
                       onKeyDown    = {this.onKeyDown} />

                {this.props.showDeleteButton && !!this.props.searchString &&
                <div className="delete-icon i5-delete" onClick={this.onSearchCancel}/>}
            </div>
        )
    }
}
